// removed by extract-text-webpack-plugin
module.exports = {"loader":"loader___U0gXU","warpper":"warpper___1_Ml1","inner":"inner___LZ9-r","spinner":"spinner___2-IFt","text":"text___27oz3","hidden":"hidden___2sYXU"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Loader/Loader.less
// module id = 715
// module chunks = 37